export const apiUrl = process.env.VUE_APP_API_BASE_URL